/* eslint-disable @typescript-eslint/camelcase */
import React from 'react';
import Grow from '@material-ui/core/Grow';
import Popper from '@material-ui/core/Popper';
import Colors from 'bit/mobiauto.web-ui-components.components.colors/colors';
import isEmpty from 'helpers/isEmpty';
import './index.css';
// overwrite the beamer config size of the button
import { connect } from 'store';
import styled from 'styled-components';

const Container = styled.div`
  padding: 12px;
  display: flex;
  align-items: center;
  width: 50px;
  height: 50px;
  color: ${Colors.gray.dark};
  box-sizing: border-box !important;
`;

class NotificationsComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isPopupNotificationOpen: false,
    };
  }
  componentDidMount() {
    if (!window.Beamer) return;
    //if the beamer is not ready to put into screen
    const beamerProps = this.buildBeamerObject();
    window.Beamer.init();
    window.Beamer.update(beamerProps);
  }
  componentWillUnmount() {
    if (!window.Beamer) return;
    window.Beamer.destroy();
  }

  buildBeamerObject = () => {
    const {
      dealerStore: { dealer = {} },
      userStore: { email, firstName },
    } = this.props;

    if (this.state.isInConsultantScreen) {
      return {};
    }

    const userId = this.parseId();
    //beamer object minimum to exist
    return {
      user_firstname: firstName,
      // Full name
      user_email: email,
      // Email address
      user_id: userId,
      company_name: dealer.name,
      company_id: dealer.id,
      dealer_id: dealer.id,
      dealer_name: dealer.name,
      products: dealer.products,
      latitude: dealer.latitude,
      longitude: dealer.longitude,
    };
  };

  parseId = () => {
    const {
      userStore: { userSite },
    } = this.props;

    if (this.state.isInConsultantScreen) {
      return undefined;
    }
    if (isEmpty(userSite) || isEmpty((userSite || {}).id)) {
      return undefined;
    }
    return parseInt(((userSite || {}).id || [])[0]);
  };

  handleToggleNotification = () => {
    this.setState(state => ({
      isPopupNotificationOpen: !state.isPopupNotificationOpen,
    }));
  };

  handleCloseNotification = event => {
    if (this.notificationAnchor.contains(event.target)) {
      return;
    }

    this.setState({ isPopupNotificationOpen: false });
  };

  render() {
    const { isPopupNotificationOpen } = this.state;
    return (
      <React.Fragment>
        <Container
          ref={node => {
            this.notificationAnchor = node;
          }}
          onClick={this.handleToggleNotification}
        />
        <Popper
          open={isPopupNotificationOpen}
          anchorEl={this.notificationAnchor}
          transition
          disablePortal
        >
          {({ TransitionProps }) => (
            <Grow
              {...TransitionProps}
              style={{ display: 'flex', flex: 1 }}
              id="isPopupNotificationOpen-beamer-selector"
            />
          )}
        </Popper>
      </React.Fragment>
    );
  }
}

const Notifications = connect(NotificationsComponent, [
  'userStore',
  'dealerStore',
]);

export default Notifications;
